export default __webpack_public_path__ + "74ff22c43d891483d6a298757843c3ba.png";